import { WindowTitle } from "@dashboard/components/WindowTitle";
import { useIntl } from "react-intl";

import { productAlertsMessages } from "./messages";
import { ProductAlertsList } from "./ProductAlertsList";

const ProductAlertsSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(productAlertsMessages.title)} />
      <ProductAlertsList />
    </>
  );
};

export default ProductAlertsSection;
